import Backbone from 'backbone';
import rootConfig from '../../../config/config';

export default Backbone.View.extend({
  initialize() {
    this.commands = editor.Commands;
  },
  events: {
    'click .menu_button': 'menuClicked'
  },

  renderElement: function({ title, className, icon }) {
    this.$el.addClass('menu_button ' + className);
    this.$el.html(
      `<img src="${rootConfig.rootDir}/assets/icons/${icon}.svg">${title}`
    );
    // this.$el.html(`<i class="fa fa-circle-o"></i>${title}`);
  },

  menuClicked: function() {
    const { model, commands } = this;
    let commandName = model.get('command');
    let command = commands.get(commandName);
    let options = {
      command: commandName
    };
    commands.runCommand(command, { ...options, sender: model });
  },

  render() {
    this.renderElement(this.model.toJSON());
    return this;
  }
});
